import React from 'react';
import styled from 'styled-components';
import { GapContainer, Heading6, Icon, P, PX_TO_REM, useTestId } from '@cmctechnology/webinvest-design-system';
import { useTranslation } from 'react-i18next';

interface IMaintenancePageProps extends React.PropsWithChildren {}

const MaintenanceBody = styled(GapContainer)`
  background: ${({ theme }) => theme.colours.palette.neutral300};
  height: 100vh;
  width: 100%;
`;

const MaintenanceContainer = styled(GapContainer)`
  width: ${PX_TO_REM[400]};
  text-align: center;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
`;

export const MaintenancePage: React.FC<React.PropsWithChildren<IMaintenancePageProps>> = ({ children, ...rest }) => {
  const { generateTestId } = useTestId(rest, 'MaintenancePage');
  const { t } = useTranslation();

  return (
    <MaintenanceBody {...generateTestId()} alignItems='center'>
      <MaintenanceContainer gutter gap='medium' column>
        <Icon name='handyman' size='xxxLarge' variant='neutral' type='outline' />
        <Heading6 headingType='SEMI_BOLD' gutter={false}>
          {t('We will be back soon')}
        </Heading6>
        <P textStyle='REGULAR' textEoraSize='SMALL'>
          {t(
            'We are currently undertaking scheduled maintenance and our share trading platform will be unavailable during this time. We apologise for any inconvenience caused.'
          )}
        </P>
      </MaintenanceContainer>
    </MaintenanceBody>
  );
};
